/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoRaffleInfoRequest model module.
 * @module model/EventsControllerDtoRaffleInfoRequest
 * @version 1.0
 */
class EventsControllerDtoRaffleInfoRequest {
    /**
     * Constructs a new <code>EventsControllerDtoRaffleInfoRequest</code>.
     * @alias module:model/EventsControllerDtoRaffleInfoRequest
     */
    constructor() { 
        
        EventsControllerDtoRaffleInfoRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoRaffleInfoRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoRaffleInfoRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoRaffleInfoRequest} The populated <code>EventsControllerDtoRaffleInfoRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoRaffleInfoRequest();

            if (data.hasOwnProperty('raffleNo')) {
                obj['raffleNo'] = ApiClient.convertToType(data['raffleNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoRaffleInfoRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoRaffleInfoRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} raffleNo
 */
EventsControllerDtoRaffleInfoRequest.prototype['raffleNo'] = undefined;






export default EventsControllerDtoRaffleInfoRequest;

